export async function getBotToken() {
    var results = await fetch("/api/bot/token").then((obj) => obj.json()).catch((ex) => console.error("get Error: " + ex));
    return results;
}